import React from "react";

import styles from "./Loading.module.scss";

export default function Loading({ message }) {
  return (
    <div className={styles.container}>
      <div className={styles.message}>{message}</div>
      <div className="spinner-border text-primary" role="status">
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
}
